import { create } from "zustand";

const categoryStore = create((set) => ({
  categories: [],

  setCategories: (data) => set({ categories: data }),

  reset: () => {
    set({ categories: [] });
  },
}));

export default categoryStore;
